import React, { useState, useEffect } from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"
import { Button } from "react-bootstrap"
import { Link } from "gatsby"

import * as slideshowStyles from "./backgroundSlideshow.module.css"

const buttonStyle = {
  backgroundColor: "#EDC02B",
  borderColor: "#EDC02B",
  borderRadius: "50px",
  fontFamily: "allotrope, sans-serif",
  fontWeight: 700,
  fontSize: "1rem",
  paddingTop: ".5rem",
  paddingLeft: "2rem",
  paddingRight: "2rem",
  marginTop: "1rem",
  color: "#426690",
}

const SLIDE_DURATION_MS = 10000
const TRANSITION_DURATION_MS = 4000

const BackgroundSliderComponent = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const data = useStaticQuery(graphql`
    query BackgroundSlideshowQuery {
      sub1: file(relativePath: { eq: "sub-1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 4000, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      sub2: file(relativePath: { eq: "sub-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 4000, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      sub3: file(relativePath: { eq: "sub-3.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 4000, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const slides = [
    data.sub1?.childImageSharp?.fluid,
    data.sub2?.childImageSharp?.fluid,
    data.sub3?.childImageSharp?.fluid,
  ].filter(Boolean)

  const photoCredits = [
    "Graphic Courtesy of Click Oil and Gas Website",
    "IDAHO 799 Departs for Alpha Sea Trials - Photo Courtesy of General Dynamics Electric Boat",
    "IDAHO 799 Returns from Bravo Sea Trials - Photo Courtesy of General Dynamics Electric Boat",
  ]

  useEffect(() => {
    if (slides.length <= 1) return
    const id = setInterval(() => {
      setCurrentIndex((i) => (i + 1) % slides.length)
    }, SLIDE_DURATION_MS)
    return () => clearInterval(id)
  }, [slides.length])

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          color: "white",
          textAlign: "center",
          backgroundColor: "#638FCB",
          width: "100%",
          padding: ".5rem",
        }}
      >
        <div>
          <h1 style={{ color: "white", marginBottom: "0" }}>
          The USS IDAHO SSN 799 is Commissioned!
          </h1>

          <div style={{ fontWeight: 500, fontSize: "1.5rem" }}>
          Thank you to our tremendous Supporters who help us make this a momentous occasion!
          </div>
        </div>
        <Button
          style={buttonStyle}
          as={Link}
          to="/upcoming-events#commissioning-information"
          className="mt-3"
        >
          Go to the Commissioning Info Page for Details
        </Button>
      </div>

      <div className={slideshowStyles.slideshow}>
        {slides.map((fluid, i) => (
          <div
            key={i}
            className={`${slideshowStyles.slide} ${
              i === currentIndex ? slideshowStyles.slideActive : ""
            }`}
            aria-hidden={i !== currentIndex}
          >
            <div className={slideshowStyles.slideImageWrapper}>
              <Img
                fluid={fluid}
                imgStyle={{ objectFit: "cover" }}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  paddingBottom: 0,
                }}
                alt=""
              />
            </div>
            {photoCredits[i] && (
              <span className={slideshowStyles.photoCredit}>
                {photoCredits[i]}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default BackgroundSliderComponent
